export default __webpack_public_path__ + "static/media/staff6.22e7ceb5.jpg";